/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataRetentionPolicy } from "./DataRetentionPolicy";
export const ListDataRetentionPoliciesResponse = core.serialization.object({
    data: core.serialization.list(DataRetentionPolicy),
});
